// Import all reducers
import advisory from './advisory';
import app from './app';
import filters from './filters';
import projects from './projects';
import projectSystemDefinition from './project-system';
import systems from './systems';
import shoppingCartToken from './shopping-cart-token';
import shoppingCartIsLoading from './shopping-cart-is-loading';
import shoppingCartError from './shopping-cart-error';

export default {
  advisory,
  app,
  filters,
  projects,
  projectSystemDefinition,
  shoppingCartError,
  shoppingCartIsLoading,
  shoppingCartToken,
  systems,
};



// WEBPACK FOOTER //
// ./js/reducers/index.js